<template>
  <div class="btn-list">
    <div class="btn-text" @click="$emit('myClick', 1)">
      <img src="@/assets/clockin_icon_poster.png" alt="" class="btn-icon" v-if="!isAdmin"/>
      <img src="@/assets/clockin_icon_plane.png" alt="" class="btn-icon" v-if="isAdmin" />
      {{isAdmin ? '发给学员' : '生成日签'}}
    </div>
    <div class="middle-line"></div>
    <div class="btn-text" @click="$emit('myClick', 2)">
      <img src="@/assets/clockin_icon_calendar.png" alt="" class="btn-icon" />
      切换日期
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="stylus" scoped>
.btn-list {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 8px;
  width: 100%;
  height: 56px;
  background: #FFF;

  .btn-icon {
    margin-right: 4px;
    width: 24px;
    height: 24px;
    border: none;
  }

  .btn-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #999;
  }

  .middle-line {
    width: 1px;
    height: 24px;
    border-radius: 25%;
    background: #E7E7E7;
  }
}
</style>
